import { createAction, props } from '@ngrx/store';
import { IBuildInfo } from '@app/api/interfaces/build-info';

export const loadBuildInfo = createAction('[AppContext] Load Build Info');

export const loadBuildInfoSuccess = createAction(
  '[AppContext] Load Build Info Success',
  props<{ data: IBuildInfo | null }>()
);

export const loadBuildInfoError = createAction('[AppContext] Load Build Info Error');
